import type { ConnectableSource, SourceConnectionStatus } from '../domain/sourceConnection';
import { classifyConnectionProbe } from '../domain/sourceConnection';
import { PROVIDER_PROBES } from './providerProbes';

export interface SourceConnectionProbe {
  status: SourceConnectionStatus;
  /** Provider-reported detail for `error` / `rejected`, when available. */
  message: string | null;
}

function readMessage(data: { error?: unknown; message?: unknown }): string | null {
  const candidate = typeof data.error === 'string' ? data.error : data.message;
  return typeof candidate === 'string' && candidate.trim() ? candidate : null;
}

/**
 * Resolve the connection status of a source through its *live* probe, so an
 * empty feed can tell "connected but empty" from "never configured" and from
 * "the provider rejected the stored credential" — the same endpoints Settings'
 * **Probar conexión** uses. Only runs while a feed is empty and idle.
 */
export async function fetchSourceConnectionStatus(
  source: ConnectableSource,
): Promise<SourceConnectionProbe> {
  try {
    const envelope = await PROVIDER_PROBES[source]();
    const message = readMessage(envelope.data);
    const status = classifyConnectionProbe({ status: envelope.data.status, message });
    return { status, message: status === 'ok' || status === 'mock' ? null : message };
  } catch {
    return { status: 'error', message: null };
  }
}
